'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var parallelBatch = require('it-parallel-batch');

var options = require('./options.js');

var index = require('./dag-builder/index.js');

var treeBuilder = require('./tree-builder.js');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var parallelBatch__default = /*#__PURE__*/_interopDefaultLegacy(parallelBatch);

function importer(_x, _x2) {
  return _importer.apply(this, arguments);
}

function _importer() {
  _importer = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, blockstore) {
    var options$1,
        opts,
        dagBuilder,
        treeBuilder$1,
        candidates,
        _iteratorAbruptCompletion,
        _didIteratorError,
        _iteratorError,
        _iterator,
        _step,
        entry,
        _args = arguments;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            options$1 = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
            opts = options(options$1);

            if (typeof options$1.dagBuilder === 'function') {
              dagBuilder = options$1.dagBuilder;
            } else {
              dagBuilder = index;
            }

            if (typeof options$1.treeBuilder === 'function') {
              treeBuilder$1 = options$1.treeBuilder;
            } else {
              treeBuilder$1 = treeBuilder;
            }

            if (Symbol.asyncIterator in source || Symbol.iterator in source) {
              candidates = source;
            } else {
              candidates = [source];
            }

            _iteratorAbruptCompletion = false;
            _didIteratorError = false;
            _context.prev = 7;
            _iterator = _asyncIterator(treeBuilder$1(parallelBatch__default['default'](dagBuilder(candidates, blockstore, opts), opts.fileImportConcurrency), blockstore, opts));

          case 9:
            _context.next = 11;
            return _awaitAsyncGenerator(_iterator.next());

          case 11:
            if (!(_iteratorAbruptCompletion = !(_step = _context.sent).done)) {
              _context.next = 18;
              break;
            }

            entry = _step.value;
            _context.next = 15;
            return {
              cid: entry.cid,
              path: entry.path,
              unixfs: entry.unixfs,
              size: entry.size
            };

          case 15:
            _iteratorAbruptCompletion = false;
            _context.next = 9;
            break;

          case 18:
            _context.next = 24;
            break;

          case 20:
            _context.prev = 20;
            _context.t0 = _context["catch"](7);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 24:
            _context.prev = 24;
            _context.prev = 25;

            if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
              _context.next = 29;
              break;
            }

            _context.next = 29;
            return _awaitAsyncGenerator(_iterator.return());

          case 29:
            _context.prev = 29;

            if (!_didIteratorError) {
              _context.next = 32;
              break;
            }

            throw _iteratorError;

          case 32:
            return _context.finish(29);

          case 33:
            return _context.finish(24);

          case 34:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[7, 20, 24, 34], [25,, 29, 33]]);
  }));
  return _importer.apply(this, arguments);
}

exports.importer = importer;